import {Modal} from 'bootstrap';

const modalsElement = document.getElementById('laravel-livewire-modals');

document.addEventListener('livewire:init', () => {
    modalsElement.addEventListener('hidden.bs.modal', () => {
        Livewire.dispatch('resetModal');
    });

    Livewire.on('showBootstrapModal', () => {
        let modal = Modal.getOrCreateInstance(modalsElement);
        modal.show();
    });

    Livewire.on('hideModal', () => {
        let modal = Modal.getInstance(modalsElement);
        modal.hide();
    });
});
